// extracted by mini-css-extract-plugin
export default {"button":"DualIconButton_button__PisUW"};